import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1440 214"
    {...props}
  >
    <g clipPath="url(#a)" fillRule="evenodd" clipRule="evenodd">
      <path
        d="M1511.99 147.507C1070 4.964-60.277 210.304-60.277 210.304l-8.406 504.453S1267.18 1078.86 1502.87 694.674l9.12-547.167Z"
        fill="#B3BAF7"
      />
      <path
        d="M-70.278 147.507C371.707 4.964 1501.99 210.304 1501.99 210.304l8.4 504.453S174.531 1078.86-61.16 694.674l-9.118-547.167Z"
        fill="#D8DFFC"
      />
      <path
        d="M308.573 44.208c2.963 7.947 20.147 10.11 11.965 21.465-.305.423-.621.884-.976 1.336-10.989 14.013-7.849 15.779 5.103 23.283 5.552 3.217 1.292 11.161-1.947 15.529-3.239 4.369-12.809 18.634-33.854 15.539-9.419-1.385-19.671-6.63-24.561-18.99-4.891-12.36 8.48-8.91 8.156-16.526-.213-4.99-10.307-10.522-5.416-26.322 4.89-15.8 10.598-5.3 11.703-15.314 1.105-10.013-3.611-22.888 13.893-20.564 17.504 2.324 12.873 12.353 15.934 20.564Z"
        fill="#6E76EE"
      />
      <path d="M293.482 147.456h-2.44V45.676h2.44v101.78Z" fill="#494951" />
      <path
        d="m292.201 82.802 1.281-.153c-2.098-9.23-16.6-14.97-17.216-15.21l-.614.828c.144.056 14.556 5.765 16.549 14.535Zm.83 27.526c1.38-5.358 11.387-8.857 11.489-8.892l-.599-.71c-.435.149-10.655 3.718-12.137 9.47l1.247.132Z"
        fill="#494951"
      />
      <path
        d="M272.886 18.968c1.571 5.545 4.204 10.883 6.307 16.325 2.164 5.6 4.346 11.299 4.32 17.137-.035 7.594-3.992 15.138-10.838 20.66-2.683 2.163-5.815 4.054-7.881 6.58-2.066 2.525-2.828 5.994-.521 8.396 3.33 3.464 10.451 2.713 15.32 4.877 6.13 2.725 6.981 9.67 3.487 14.374-3.495 4.705-19.409 18.164-42.117 14.831-10.163-1.492-23.94-8.857-23.547-16.734.41-8.201 10.694-14.844 10.344-23.047-.23-5.374-4.974-9.916-9.081-14.29-4.107-4.374-7.933-9.702-6.042-14.883 2.783-7.626 15.68-9.981 21.926-16.308 4.021-4.074 4.907-9.433 5.157-14.526.249-5.094.079-10.314 2.309-15.12 5.412-11.654 24.625-10.264 30.857 11.728Z"
        fill="#BE99EE"
      />
      <path d="M248.635 148.098h-2.438V47.036h2.438v101.062Z" fill="#2E2F34" />
      <path
        d="m247.355 83.901 1.28-.152c-2.097-9.165-16.594-14.864-17.209-15.103l-.614.822c.144.056 14.551 5.725 16.543 14.433Zm.829 27.332c1.38-5.319 11.383-8.794 11.484-8.828l-.599-.706c-.434.148-10.65 3.692-12.132 9.404l1.247.13Z"
        fill="#2E2F34"
      />
      <path
        d="M1209.99 67.722c-.73 2.55-1.94 5.004-2.9 7.506-1 2.576-2 5.196-1.99 7.88.01 3.492 1.83 6.96 4.98 9.5 1.24.995 2.68 1.864 3.63 3.026.95 1.16 1.3 2.756.24 3.86-1.54 1.593-4.81 1.248-7.05 2.243-2.82 1.253-3.21 4.446-1.6 6.609 1.6 2.163 8.92 8.352 19.36 6.82 4.68-.686 11.01-4.073 10.83-7.695-.19-3.771-4.92-6.825-4.76-10.597.11-2.471 2.29-4.56 4.18-6.57 1.89-2.012 3.65-4.462 2.78-6.844-1.28-3.507-7.21-4.59-10.08-7.5-1.85-1.872-2.26-4.337-2.37-6.679-.12-2.342-.04-4.742-1.07-6.952-2.49-5.359-11.32-4.72-14.18 5.393Z"
        fill="#BE99EE"
      />
      <path d="M1221.14 127.098h1.12v-46.47h-1.12v46.47Z" fill="#2E2F34" />
      <path
        d="m1221.72 97.58-.58-.07c.96-4.215 7.63-6.836 7.91-6.945l.28.378c-.07.025-6.69 2.632-7.61 6.636Zm-.38 12.567c-.63-2.446-5.23-4.044-5.28-4.06l.28-.324c.2.068 4.9 1.698 5.58 4.324l-.58.06Z"
        fill="#2E2F34"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(-71)" d="M0 0h1584v214H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgComponent;
